<template>
  <div class="badge">{{ text }}</div>
</template>

<script>
  export default {
    name: 'ProductTileBadge',
    props: {
      text: String
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/abstracts/__dir';
  @import '../../scss/global/__dir';

  .badge {
    background-color: #d45656;
    border-radius: 3px;
    color: #fff;
    display: inline-block;
    font-family: $font-primary-bold;
    font-size: 10px;
    padding: 6px 8px 7px;
    pointer-events: none;
    text-transform: capitalize;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/js/components/ProductTileBadge.vue